// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

import { ready } from '@dsbunny/rmm-client';
import { BrowserKuromiEngine } from './browser-kuromi-engine.js';
import { ISSUER } from './config.js';
import './components.js';
export { WebPlaylistElement, WebGLPlaylistElement } from '@dsbunny/miffy-current/web';

(async () => {
	try {
		await ready;
		if(typeof window.dsbunny === 'undefined') {
			throw new Error('window.dsbunny is not defined.');
		}
		if(typeof ISSUER === 'undefined') {
			throw new Error('ISSUER is not defined.');
		}
		const userCodeElement = document.querySelector('#user_code');
		if(userCodeElement === null) {
			throw new Error('`user_code` element not found');
		}
		const verificationUriElement = document.querySelector('#verification_uri');
		if(verificationUriElement === null) {
			throw new Error('`verification_uri` element not found');
		}
		const qrContainerElement = document.querySelector("#qr");
		if(qrContainerElement === null) {
			throw new Error('`qr` element not found');
		}
		window.dsbunny.engine = new BrowserKuromiEngine({
			userCodeElement,
			verificationUriElement,
			qrContainerElement,
		});
		window.dsbunny.engine.start({ issuer_url: ISSUER });
	} catch(error: unknown) {
		console.error(`Failed to start BrowserKuromiEngine: ${error}`);
	}
})();
